/**
 * List of valid NetStorage environments.
 */
export type NetStorageEnv =
	| 'dev'
	| 'ftdev'
	| 'ftsit'
	| 'prod'
	| 'prod2'
	| 'project'
	| 'rcdev'
	| 'rcsit'
	| 'sit'
	| 'test'

type NetStorageSuffixes = '-global_nav.html' | '-global_footer.html'

/**
 * Constructs a string URL for content in Akamai NetStorage.
 * @param variation Variation of content, e.g 'chevrolet-us-en-standard'
 * @param suffix File suffix, currently only '-global_nav.html' or '-global_footer.html'.
 * @param baseOverride Optional base URL override. Used for lower environments.
 */
export const getNetStorageContentPath = (
	variation: string,
	suffix: NetStorageSuffixes,
	baseOverride?: string
): string => {
	const baseUrl = '/_gbpe/content-service/prod1/'
	const overrideEndsWithSlash = baseOverride?.endsWith('/')
	const correctedOverride = `${baseOverride}${!overrideEndsWithSlash ? '/' : ''}`
	let url = ''
	if (baseOverride?.includes('experience-fragments')) {
		url = `${baseOverride}`
	} else {
		url = `${baseOverride ? correctedOverride : baseUrl}${variation}${suffix}`
	}
	return url
}
